/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import util from "util/util.js";

var promise;
var status = "not loaded";

// var key = "AIzaSyCArNiTwfnfRqjzuJWlCnHKCJ892jGMdZE";
var key = "AIzaSyDTbXofXERMpH8byQTs4Tq1rcVmjWJboJE";

function retryLoad() {
	let loadPromise = new Promise(function(resolve, reject) {
		window.googleMapsCallback = function() {
			status = "loaded";
			resolve();
		};
		var script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = 'https://maps.googleapis.com/maps/api/js?v=quarterly&libraries=geometry,places,drawing&callback=googleMapsCallback&key=' + key;
		document.body.appendChild(script);
	});

	return Promise.race([
		loadPromise,
		util.delay(300000).then(() => "Timeout")
	]).then(function(result) {
		if(result === "Timeout") {
			console.log("Failed to load Google Maps - retrying");
			status = "retrying";
			return retryLoad();
		}
	});
}

function load() {
	if(!promise) {
		promise = retryLoad();
	}
	return promise;
}

function staticMapURL(params) {
	return 'https://maps.googleapis.com/maps/api/staticmap?' + util.encodeParams(params) + "&key=" + key;
}

//----


function MarkerMapType(tileSize, map, setupTile, releaseTile) {
	this.tileSize = tileSize;
	this.map = map;
	this.userSetupTile = setupTile;
	this.userReleaseTile = releaseTile;
}

MarkerMapType.prototype.tileCoordToLatLng = function(coord, zoom) {
	var numTiles = 1 << zoom;

	var pixelCoord = new google.maps.Point(
		coord.x * this.tileSize.width,
		coord.y * this.tileSize.height
	);

	var worldCoord = new google.maps.Point(
		pixelCoord.x / numTiles,
		pixelCoord.y / numTiles
	);

	return this.map.getProjection().fromPointToLatLng(worldCoord);
};

MarkerMapType.prototype.getTile = function(coord, zoom, ownerDocument) {
	var div = ownerDocument.createElement('div');
	var tileContext = {};
	var self = this;
	div._tileContext = tileContext; // Attach context so we can access it in releaseTile

	var nw = this.tileCoordToLatLng(coord, zoom);
	var se = this.tileCoordToLatLng(new google.maps.Point(coord.x + 1, coord.y + 1), zoom);

	if(self.userSetupTile) self.userSetupTile(coord, zoom, nw, se, tileContext, this.map);

	return div;
};

MarkerMapType.prototype.releaseTile = function(tile) {
	var tileContext = tile._tileContext;

	if(self.userReleaseTile) self.userReleaseTile(tileContext);

	(tileContext.markers || []).forEach(function(marker) {
		marker.setMap(null);
		google.maps.event.clearInstanceListeners(marker);
	});

	tileContext.released = true;
};

//----- Ripple view

function RippleView(map) {
	var self = this;
	this.map = map;

	var overlay = new google.maps.OverlayView();
	overlay.onAdd = function() {
		self.div = document.createElement('div');
		this.getPanes().overlayLayer.appendChild(self.div);
	};
	overlay.draw = function() {};
	overlay.onRemove = function() {
		self.div.parentElement.removeChild(self.div);
	};
	overlay.setMap(map);

	this.overlay = overlay;
}

RippleView.prototype.removeRipple = function() {
	if(this.rippleDiv) {
		this.rippleDiv.parentElement.removeChild(this.rippleDiv);
		delete this.rippleDiv;
	}
	if(this.removeTimer) {
		clearTimeout(this.removeTimer);
		delete this.removeTimer;
	}
};

RippleView.prototype.ripple = function(latLng) {
	var proj = this.overlay.getProjection();

	// Retrieve the south-west and north-east coordinates of this overlay
	// in LatLngs and convert them to pixel coordinates.
	// We'll use these coordinates to resize the div.
	var point = proj.fromLatLngToDivPixel(latLng);

	var self = this;

	this.removeRipple();

	this.rippleDiv = document.createElement('div');
	this.rippleDiv.className = 'ripple';
	this.rippleDiv.style.top = point.y + 'px';
	this.rippleDiv.style.left = point.x + 'px';
	this.div.appendChild(this.rippleDiv);

	requestAnimationFrame(function() {
		self.rippleDiv.classList.add("fade");
	});

	this.removeTimer = setTimeout(function() {
		self.removeRipple();
	}, 1000);
};

//----
function extendAPI() {
	if(google.maps.hasExtendedAPI) return;
	google.maps.hasExtendedAPI = true;

	google.maps.Polygon.prototype.getBounds = function() {
			var bounds = new google.maps.LatLngBounds();
			var paths = this.getPaths();
			var path;
			for (var i = 0; i < paths.getLength(); i++) {
					path = paths.getAt(i);
					for (var ii = 0; ii < path.getLength(); ii++) {
							bounds.extend(path.getAt(ii));
					}
			}
			return bounds;
	};
}

//---


// This helper makes it easier to detect single clicks with Google Maps. It adds two new events:
// 'firstclick' - called whenever a click event occurs, unless a click has already occured in the last 300ms
// 'singleclick' - called 300ms after a click if no other clicks have occured
function addSingleClickEvents(target) {
	var delay = 300;
	var clickTimer;
	var lastClickTime = 0;

	google.maps.event.addListener(target, 'click', handleClick);
	google.maps.event.addListener(target, 'dblclick', handleDoubleClick);

	function handleClick(e) {
		var clickTime = +new Date();

		var timeSinceLastClick = clickTime - lastClickTime;

		if(timeSinceLastClick > delay) {
			google.maps.event.trigger(target, 'firstclick', e);

			clickTimer = setTimeout(function() {
				google.maps.event.trigger(target, 'singleclick', e);
			}, delay);
		} else {
			clearTimeout(clickTimer);
		}

		lastClickTime = clickTime;
	}

	function handleDoubleClick(e) {
		clearTimeout(clickTimer);
		lastClickTime = +new Date();
	}
}

function mapTypeSelectorControl(map, types) {
	if(!types) {
		types = [
			{
				name: 'Map',
				id: google.maps.MapTypeId.TERRAIN
			},
			{
				name: 'Satellite',
				id: google.maps.MapTypeId.HYBRID
			}
		];
	}

	var control = document.createElement('div');
	control.className ='map-type-selector';

	types.forEach(function(type) {
		var div = document.createElement('div');
		div.textContent = type.name;
		div.setAttribute('data-type-id', type.id);
		div.addEventListener('click', function() {
			map.setMapTypeId(type.id);
		});
		control.appendChild(div);
	});

	google.maps.event.addListener(map, 'maptypeid_changed', update);

	function update() {
		var id = map.getMapTypeId();

		for(let div of control.getElementsByTagName("div")) {
			if(div.getAttribute('data-type-id') == id) {
				div.classList.add('selected');
			} else {
				div.classList.remove('selected');
			}
		};
	}

	update();

	return control;
}

function zoomControl(map) {
	var control = document.createElement('div');
	control.className = 'map-zoom-control';

	var plus = document.createElement('div');
	plus.textContent = '+';
	plus.className = 'plus';
	plus.addEventListener('click', function() {
		map.setZoom(map.getZoom() + 1);
	});

	var minus = document.createElement('div');
	minus.textContent = '–';
	minus.className = 'minus';
	minus.addEventListener('click', function() {
		map.setZoom(map.getZoom() - 1);
	});

	control.appendChild(plus);
	control.appendChild(minus);

	return control;
}

// Zero-dependencies drag zoom control
function dragZoomControl(map) {
	var drawingManager = new google.maps.drawing.DrawingManager();

	drawingManager.setOptions({
		drawingMode : google.maps.drawing.OverlayType.RECTANGLE,
		drawingControl : false,
		rectangleOptions : {
			strokeColor : 'black',
			strokeWeight : 1,
			fillColor : 'black',
			fillOpacity : 0.1,
			editable: false,
		  draggable: false
		}
	});

	var iconSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 139.3 134.35"><g><path d="M 0 0 L 0 15 L 15 15 L 15 0 L 0 0 z M 30 0 L 30 15 L 45 15 L 45 0 L 30 0 z M 60 0 L 60 15 L 75 15 L 75 0 L 60 0 z M 90 0 L 90 15 L 105 15 L 105 0 L 90 0 z M 0 30 L 0 45 L 15 45 L 15 30 L 0 30 z M 90 30 L 90 45 L 105 45 L 105 30 L 90 30 z M 85 50 C 66 50 50 66 50 85 C 50 104 66 120 85 120 C 93 120 101 117 107 112 L 129 134 L 139 124 L 116 101 C 119 96 120 91 120 85 C 120 66 104 50 85 50 z M 0 60 L 0 75 L 15 75 L 15 60 L 0 60 z M 85 60 C 99 60 110 71 110 85 C 110 99 99 110 85 110 C 71 110 60 99 60 85 C 60 71 71 60 85 60 z M 0 90 L 0 105 L 15 105 L 15 90 L 0 90 z M 30 90 L 30 105 L 45 105 L 45 90 L 30 90 z " /></g></svg>';

	if(!dragZoomControl.stylesAdded) {
		var css = '.drag-zoom svg, .drag-zoom.active:hover svg { fill: #666; } .drag-zoom:hover svg { fill: #333; }';

		var style = document.createElement('style');
		if(style.styleSheet) {
			style.styleSheet.cssText = css;
		} else {
			style.appendChild(style.appendChild(document.createTextNode(css)));
		}
		document.getElementsByTagName('head')[0].appendChild(style);
		dragZoomControl.stylesAdded = true;
	}

	var control = document.createElement('div');
	control.className = 'drag-zoom';
	control.innerHTML = iconSvg;
	// Note - these values are based on the default Google Maps zoom buttons
	control.style.background = 'white';
	control.style.width = '40px';
	control.style.height = '40px';
	control.style.marginRight = '10px';
	control.style.borderRadius = '2px';
	control.style.padding = '7px';
	control.style.boxShadow = 'rgba(0, 0, 0, 0.3) 0px 1px 4px -1px';
	control.style.cursor = 'pointer';
	control.title = 'Zoom in by dragging a rectangle on the map (shortcut: SHIFT + drag)'

	var isActive = false;
	function setActive(active) {
		drawingManager.setMap(active ? map : null);
		control.style.background = active ? '#333' : 'white';
		control.className = active ? 'drag-zoom active' : 'drag-zoom';
		isActive = active;
	}

	google.maps.event.addListener(drawingManager, 'overlaycomplete', function(event) {
		if(event.type == google.maps.drawing.OverlayType.RECTANGLE) {
			event.overlay.setMap(null);
			map.fitBounds(event.overlay.getBounds());
			setActive(isShiftKeyDown);
		}
	});

	function isShiftKey(event) {
		var key = event.key || event.keyCode;
		return key === 'Shift' || key == 16;
	}

	var isShiftKeyDown = false;
	document.addEventListener('keydown', function(event) {
		if(isShiftKey(event)) {
			isShiftKeyDown = true;
			setActive(true);
		}
	});

	document.addEventListener('keyup', function(event) {
		if(isShiftKey(event)) {
			isShiftKeyDown = false;
			setActive(false);
		}
	});

	control.addEventListener('click', function(event) {
		if(!isShiftKeyDown) {
			setActive(!isActive);
		}
	});

	return control;
}

function coordinateControl(map) {
	let control = document.createElement('div');

	// Dummy overlay so that we can access MapCanvasProjection
	let overlay = new google.maps.OverlayView();
	overlay.draw = function(){};
	overlay.onAdd = function() {
		this.projectionAvailable = true;
	};
	overlay.onRemove = function() {};
	overlay.setMap(map);

	control.className = 'map-coordinate-control';

	function setLocation(latLng) {
		if(latLng) {
			control.style.visibility = 'visible';
			control.textContent = util.formatDecimalCoordinates({
				lat: latLng.lat(),
				lon: latLng.lng()
			});
		} else {
			control.style.visibility = 'hidden';
		}
	}

	// Note: adding the event listener to the map div instead of the map object avoids
	// issues with various map elements (polygons, drawing tool etc.) swallowing events
	// before we can get to them.
	map.getDiv().addEventListener('mousemove', function(event) {
		if(overlay.projectionAvailable) {
			let projection = overlay.getProjection();
			let divRect = map.getDiv().getBoundingClientRect();
			let divPixel = new google.maps.Point(
				event.clientX - divRect.left,
				event.clientY - divRect.top);
			setLocation(projection.fromContainerPixelToLatLng(divPixel));
		}
	});
	map.getDiv().addEventListener('mouseout', function(event) {
		setLocation(null);
	});

	control.setLocation = setLocation;

	return control;
}

function instructionsControl() {
	const div = document.createElement('div');
	div.style.backgroundColor = 'rgba(0,0,0,0.3)';
	div.style.color = 'white';
	div.style.padding = '1em';
	div.style.marginBottom = '1.5em';
	div.style.borderRadius = '1.5em';
	div.style.display = 'none';
	return div;
}

// ------ Hover Overlay

function hoverOverlay(map) {
	var hoverDiv = document.createElement('div');
	hoverDiv.className = 'map-hover';
	hoverDiv.style.display = 'none';

	var overlay = new google.maps.OverlayView();
	overlay.draw = function(){};
	overlay.onAdd = function() {
		this.getPanes().floatPane.appendChild(hoverDiv);
	};
	overlay.onRemove = function() {
		hoverDiv.parentElement.removeChild(hoverDiv);
	};

	overlay.position = function(latLng) {
		var point = overlay.getProjection().fromLatLngToDivPixel(latLng);

		var x = point.x;
		var y = point.y;

		var flipX = map.getCenter().lng() < latLng.lng();
		var flipY = map.getCenter().lat() > latLng.lat();

		hoverDiv.style.display = 'inline-block';
		hoverDiv.style.left = (flipX ? x - hoverDiv.offsetWidth - 10 : x + 10) + 'px';
		hoverDiv.style.top = (flipY ? y - hoverDiv.offsetHeight - 10 : y + 10) + 'px';
	};

	overlay.html = function(content) {
		hoverDiv.innerHTML = content;
	};

	overlay.show = function() {
		hoverDiv.style.display = 'inline-block';
	};

	overlay.hide = function() {
		hoverDiv.style.display = 'none';
	};

	overlay.setMap(map);

	return overlay;
}

// --- End hover overlay

function bounds(b, existing) {
	var sw = new google.maps.LatLng(b.miny, b.minx);
	var ne = new google.maps.LatLng(b.maxy, b.maxx);
	if(existing) {
		return existing.extend(sw).extend(ne);
	} else {
		return new google.maps.LatLngBounds(sw, ne);
	}
}

function outsetBounds(b, delta) {
	var sw = { lat: b.getSouthWest().lat() - delta, lng: b.getSouthWest().lng() - delta };
	var ne = { lat: b.getNorthEast().lat() + delta, lng: b.getNorthEast().lng() + delta };
	return new google.maps.LatLngBounds(sw, ne);
}

function scaleBounds(b, scale) {
	var span = b.toSpan();
	var latDelta = span.lat() * (scale - 1);
	var lngDelta = span.lng() * (scale - 1);
	var sw = { lat: b.getSouthWest().lat() - latDelta, lng: b.getSouthWest().lng() - lngDelta };
	var ne = { lat: b.getNorthEast().lat() + latDelta, lng: b.getNorthEast().lng() + lngDelta };
	return new google.maps.LatLngBounds(sw, ne);
}

function defaultOptions(opts) {
	return {
		zoomControl: true,
		zoomControlOptions: {
			style: google.maps.ZoomControlStyle.SMALL,
			position: google.maps.ControlPosition.RIGHT_BOTTOM
		},
		mapTypeId: google.maps.MapTypeId.TERRAIN,
		scaleControl: true,
		scaleControlOptions: {
			position: google.maps.ControlPosition.RIGHT_BOTTOM
		},
		disableDefaultUI: true,
		streetViewControl: false,
		panControl: false,
		fullscreenControl: true,
		mapTypeControl: true,
		mapTypeControlOptions: {
			style: google.maps.MapTypeControlStyle.DEFAULT,
			position: google.maps.ControlPosition.LEFT_BOTTOM
		},
		styles: [{
			featureType: 'road',
			elementType: 'labels.icon',
			stylers: [{ visibility: 'off' }]
		}, {
			featureType: 'poi',
			elementType: 'labels',
			stylers:[{
				visibility:"off"
			}]
		}],
		gestureHandling: 'greedy', // Prevents 'hold key to scroll' message
		tilt: 0, // Prevent 3d mode when zoomed in
		cameraControl: false,
		...opts
	};
}

function preventAccidentalScroll(map) {
		var timeout;
		window.addEventListener('wheel', function() {
				if(timeout) {
						clearTimeout(timeout);
				} else {
						map.setOptions({ scrollwheel: false });
				}
				timeout = setTimeout(function() {
						map.setOptions({ scrollwheel: true });
						timeout = null;
				}, 200);
		});
}

// --- Bounds contains check

function containsRange(amin, amax, bmin, bmax) {
	if(amin <= amax) {
		if(bmin <= bmax) {
			return amin <= bmin && amax >= bmax;
		} else {
			return false;
		}
	} else {
		if(bmin <= bmax) {
			return amin <= bmin || amax >= bmax;
		} else {
			return amin <= bmin && amax >= bmax;
		}
	}
}

function containsBounds(a, b) {
	var asw = a.getSouthWest(),
		bsw = b.getSouthWest(),
		ane = a.getNorthEast(),
		bne = b.getNorthEast();

	return containsRange(asw.lat(), ane.lat(), bsw.lat(), bne.lat()) &&
		containsRange(asw.lng(), ane.lng(), bsw.lng(), bne.lng());
}


// Encoded path is not URL friendly so we end up with a bunch of %XX in the URL
// To avoid this, we map the characters to the same range used by base64url encoding (RFC 4648)
function encodedPathToBase64(encodedPath) {
	return String.fromCharCode.apply(String, Array.from(encodedPath).map(function(x) {
		x = x.charCodeAt(0) - 63;

		return (x < 26) ? x + 65 : // A-Z
			(x < 52) ? x - 26 + 97 : // a-z
			(x < 62) ? x - 52 + 48 : // 0-9
			(x < 63) ? 45 : 95; // -, _
	}));
}

function encodedPathFromBase64(encodedPathBase64) {
	return String.fromCharCode.apply(String, Array.from(encodedPathBase64).map(function(x) {
		x = x.charCodeAt(0);
		var A = 65, Z = 90, a = 97, z = 122, _0 = 48, _9 = 57, minus = 45; // ASCII codes

		return 63 + (
				(x >= A && x <= Z) ? x - A :
				(x >= a && x <= z) ? x + 26 - a :
				(x >= _0 && x <= _9) ? x + 52 - _0 :
				(x == minus) ? 62 : 63
			);
	}));
}

function googleMapsURL(lat, lon) {
	return 'https://www.google.com/maps/search/?api=1&query=' + lat + ',' + lon;
}

function addFeatureToMap(feature, map) {
	var geometry = feature.data;
	if(feature.type == "POLYGON") {
		geometry = [geometry];
	} else if(feature.type != "MULTIPOLYGON") {
		console.log("Unsupported tile geometry: " + feature.type);
		return;
	}

	geometry.forEach(function(poly_geom) {
		var paths = poly_geom.map(function(path_geom) {
			return google.maps.geometry.encoding.decodePath(path_geom);
		});

		new google.maps.Polygon({
			paths: paths,
			map: map,
			fillColor: "purple",
			strokeColor: "purple",
			strokeWeigth: 2,
			fillOpacity: 0.3
		});
	});
}

export default {
	load,
	status: function() { return status; },
	MarkerMapType,
	RippleView,
	extendAPI,
	hoverOverlay,
	addSingleClickEvents,
	mapTypeSelectorControl,
	dragZoomControl,
	coordinateControl,
	zoomControl,
	instructionsControl,
	bounds,
	outsetBounds,
	scaleBounds,
	defaultOptions,
	preventAccidentalScroll,
	containsBounds,
	encodedPathToBase64,
	encodedPathFromBase64,
	staticMapURL,
	googleMapsURL,
	addFeatureToMap
};
